import { combineReducers } from "redux";
import ExchangeHolidayReducer from "./ExchangeHoliday";
import circularUpdateReducer from "./CirculareUpdate";
import LocateReducer from "./LocateUs";
import FaqListReducer from "./FaqList";
export default combineReducers({
    ExchangeHolidayReducer: ExchangeHolidayReducer,
    circularUpdateReducer: circularUpdateReducer,
    LocateReducer: LocateReducer,
    FaqListReducer: FaqListReducer,
});
